import _ from 'lodash';

import { PAYMENT_TYPE_BANK, PAYMENT_TYPE_PAYPAL } from '../data/billing';

export const isWireTransferPayment = (paymentBaseType) =>
  _.includes([PAYMENT_TYPE_BANK, PAYMENT_TYPE_PAYPAL], paymentBaseType);
